import { handleAuthResponse } from '../auth';

const API_URL = process.env.REACT_APP_API_URL;

// Public: get all active badges
export const getBadges = () => {
    return fetch(`${API_URL}/badges`, {
        method: 'GET',
        credentials: 'include',
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || 'Network error' }; });
};

// Public: verify a badge by credential UUID
export const verifyBadge = (uuid) => {
    return fetch(`${API_URL}/badge/verify/${uuid}`, {
        method: 'GET',
        credentials: 'include',
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || 'Network error' }; });
};

// Admin: get all badges including revoked
export const getAllBadges = () => {
    return fetch(`${API_URL}/badges/all`, {
        method: 'GET',
        credentials: 'include',
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || 'Network error' }; });
};

// Admin: create a new badge (multipart — supports image upload)
export const createBadge = (badgeData, imageFile) => {
    const formData = new FormData();
    formData.append('badgeTypeId', badgeData.badgeTypeId);
    formData.append('recipientName', badgeData.recipientName);
    formData.append('recipientEmail', badgeData.recipientEmail);
    formData.append('year', badgeData.year);
    formData.append('message', badgeData.message || '');
    formData.append('credentialJson', JSON.stringify(badgeData.credentialJson));

    if (imageFile) {
        formData.append('badgeImage', imageFile);
    }

    return fetch(`${API_URL}/badge/create`, {
        method: 'POST',
        credentials: 'include',
        // Don't set Content-Type — browser sets it with multipart boundary
        body: formData,
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || 'Network error' }; });
};

// Admin: revoke a badge
export const revokeBadge = (badgeId) => {
    return fetch(`${API_URL}/badge/revoke/${badgeId}`, {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        credentials: 'include',
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || 'Network error' }; });
};

// Admin: delete a badge
export const deleteBadge = (badgeId) => {
    return fetch(`${API_URL}/badge/${badgeId}`, {
        method: 'DELETE',
        credentials: 'include',
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || 'Network error' }; });
};
